export function WarningTriangleIcon() {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20">
      <mask id="warning-triangle-cutout" maskUnits="userSpaceOnUse">
        <rect fill="white" height="20" width="20" />
        <path d="M10 7.5v3.333" stroke="black" strokeLinecap="round" strokeWidth="1.2" />
        <circle cx="10" cy="14.167" fill="black" r="0.625" />
      </mask>
      <path
        d="M8.575 3.217 1.517 15a1.667 1.667 0 0 0 1.425 2.5h14.117a1.667 1.667 0 0 0 1.425-2.5L11.425 3.217a1.667 1.667 0 0 0-2.85 0Z"
        fill="#EF4444"
        mask="url(#warning-triangle-cutout)"
      />
    </svg>
  )
}
